<template>
  <SbButton
    v-if="buttonLabel"
    :is-disabled="disabled"
    :label="buttonLabel"
    variant="secondary"
  />
  <SbIconButton
    v-else
    tooltip-position="top"
    :is-disabled="disabled"
    :label="tooltipLabel"
    :icon="icon"
    variant="quaternary"
    is-clear
  />
</template>

<script lang="ts" setup>
import SbButton from '../../Button/SbButton.vue'
import SbIconButton from '../../IconButton/SbIconButton.vue'
import type { IconName } from '../../Icon'

withDefaults(
  defineProps<{
    disabled?: boolean
    icon?: IconName
    tooltipLabel?: string
    buttonLabel?: string
  }>(),
  {
    disabled: false,
    tooltipLabel: '',
    buttonLabel: '',
  },
)
</script>
